import React, { useState, useEffect, Component } from "react";
import Footer from "../../Shared/Footer/Footer";
import NavigationBar from "../../Shared/NavigationBar/NavigationBar";
import dataBG from "../../../Images/Product & Services/DataS/dataBannerBg.png";
import commonScope from "../../../Images/Product & Services/DataS/commonScope.png";
import rosenberger2 from "../../../Images/Product & Services/DataS/rossenberger2.jpg";
import rosenberger3 from "../../../Images/Product & Services/DataS/rosenberger3.jfif";
import rosenberger4 from "../../../Images/Product & Services/DataS/rossenberger3.jpg";
import rosenberger from "../../../Images/Product & Services/DataS/rosenberger.png";
import dataBox from "../../../Images/Product & Services/DataS/databox.png";
import dataBox2 from "../../../Images/Product & Services/DataS/databox2.png";
import dataLogo from "../../../Images/Product & Services/DataS/topLogo.png";
import hardSolu from "../../../Images/Product & Services/DataS/Hardware-solutions.png";
import manageSer from "../../../Images/Product & Services/DataS/manage-service.png";
import dcLowerBg from "../../../Images/Product & Services/DataS/DCLowerPage.png";
import securityServillience from "../../../Images/Product & Services/DataS/security and servillience.png";
import "./DataCenter.css";
import { faFileArrowDown, faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Slider from "react-slick";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const DataCenter = () => {
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownload = () => {
    setIsDownloading(true);
    const link = document.createElement("a");
    link.href = "/";
    link.download = "/";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setIsDownloading(false);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // react slick
  const settings = {
    dots: true,
    infinite: true,

    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
  };
  // Reload 0
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="">
      <section>
        <NavigationBar />
      </section>
      <section className="data-div-banner">
        <div>
          <img className="data-banner img img-fluid" src={dataBG} alt="" />
        </div>
      </section>
      <section className="data-mobile-texts-div">
        <div className="data-mobile-texts">
          <div className="d-flex align-items-center text-center">
            <img src={dataLogo} alt="" />
            <h5 className="data-head-tag ms-2">Data center Infra Solution</h5>
          </div>
          <p className="data-p1">
            A Comprehensive architectural solution for growing{" "}
            <span className="data-p1-span">BUSINESS</span>
          </p>
          <p className="data-p2">
            A data center infrastructure solution typically refers to the
            hardware and software components that make up a data center,
            including servers, storage systems, network equipment, backup and
            disaster recovery systems, and various management tools. The goal of
            a data center infrastructure solution is to provide a secure,
            scalable, and reliable platform for storing, processing, and
            managing large amounts of data and applications. A comprehensive
            data center infrastructure solution may also include features such
            as virtualization, cloud computing, and automation to maximize
            efficiency and reduce costs.
          </p>
        </div>
      </section>
      <section className="data-texts-div ">
        <div className="data-mobile-texts container-fluid">
          <div className="d-flex align-items-center text-center">
            <img src={dataLogo} alt="" />
            <h5 className="data-head-tag ms-2">Data center Infra Solution</h5>
          </div>
          <p className="data-p1">
            A Comprehensive architectural solution for growing{" "}
            <span className="data-p1-span">BUSINESS</span>
          </p>
          <p className="data-p2">
            A data center infrastructure solution typically refers to the
            hardware and software components that make up a data center,
            including servers, storage systems, network equipment, backup and
            disaster recovery systems, and various management tools. The goal of
            a data center infrastructure solution is to provide a secure,
            scalable, and reliable platform for storing, processing, and
            managing large amounts of data and applications. A comprehensive
            data center infrastructure solution may also include features such
            as virtualization, cloud computing, and automation to maximize
            efficiency and reduce costs.
          </p>
        </div>
        <div className="data-buttons">
          <button
            className="data-download-file-soft"
            Click={handleDownload}
            disabled={isDownloading}
          >
            {" "}
            <span className="me-2">
              <FontAwesomeIcon icon={faFileArrowDown} />
            </span>
            {isDownloading ? "Downloading..." : "Download Brochure"}
          </button>
          <button className=" ms-2 me-2 data-button1" type="submit">
            Request a demo
          </button>
        </div>
      </section>
      <div className="container-fluid full-tab-div">
        <div className="data-fe-icons-div container">
          <h3 className="data-fe-icons">Solutions We Cover</h3>
        </div>
        <div className="row ">
          <Box
            sx={{
              flexGrow: 1,
              bgcolor: "#f8f8f8",
              display: "flex",
              height: 350,
            }}
          >
            <div className="col-4">
              <Tabs
                orientation="vertical"
                variant=""
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                sx={{ borderRight: 0, borderColor: "divider" }}
              >
                <Tab label="CommonScope" {...a11yProps(0)} />
                <Tab label="RosenBerger" {...a11yProps(1)} />
                <Tab label="PAC (Precision AC)" {...a11yProps(2)} />
                <Tab label="EMS" {...a11yProps(3)} />
                <Tab label="Online UPS" {...a11yProps(4)} />
                <Tab label="Fire" {...a11yProps(5)} />
              </Tabs>
            </div>
            <div className="col-8">
              <div className="row">
                <div className="col">
                  {" "}
                  <TabPanel value={value} index={0}>
                    <Slider {...settings}>
                      <div className="fixprop-img mb-5">
                        <img
                          className="img img-fluid"
                          src={commonScope}
                          alt=""
                        />
                      </div>
                      {/* <div className="fixprop-img mb-5">
                        <img
                          className="img img-fluid"
                          src={rosenberger}
                          alt=""
                        />
                      </div> */}
                      <div className="fixprop-img mb-5">
                        <img className="img img-fluid" src={dataBox} alt="" />
                      </div>
                      <div className="fixprop-img mb-5">
                        <img className="img img-fluid" src={dataBox2} alt="" />
                      </div>
                    </Slider>
                    <br />
                    <br />

                    <p>
                      CommScope Inc. is an American global network
                      infrastructure provider company.
                      <br /> “SYSTIMAX” is one of the world's leading networking
                      solutions portfolio under CommScope.
                    </p>
                    <ul>
                      <li>
                        Total IT Infrastructure Solution (Copper & Fiber).
                      </li>
                    </ul>
                  </TabPanel>
                </div>
              </div>
            </div>
            <div className="col-8">
              <div className="row">
                <div className="col">
                  {" "}
                  <TabPanel value={value} index={1}>
                    <Slider {...settings}>
                      <div className="fixprop-img mb-5">
                        <img
                          className="img img-fluid"
                          src={rosenberger}
                          alt=""
                        />
                      </div>
                      <div className="fixprop-img mb-5">
                        <img
                          className="img img-fluid"
                          src={rosenberger2}
                          alt=""
                        />
                      </div>
                      <div className="fixprop-img mb-5">
                        <img
                          className="img img-fluid"
                          src={rosenberger3}
                          alt=""
                        />
                      </div>
                      <div className="fixprop-img mb-5">
                        <img
                          className="img img-fluid"
                          src={rosenberger4}
                          alt=""
                        />
                      </div>
                    </Slider>
                    <br />
                    <br />

                    <p>
                      CommScope Inc. is an American global network
                      infrastructure provider company.
                      <br /> “SYSTIMAX” is one of the world's leading networking
                      solutions portfolio under CommScope.
                    </p>
                    <ul>
                      <li>
                        Total IT Infrastructure Solution (Copper & Fiber).
                      </li>
                    </ul>
                  </TabPanel>
                </div>
              </div>
            </div>
            <TabPanel value={value} index={2}>
              Item Three
            </TabPanel>
            <TabPanel value={value} index={3}>
              Item Four
            </TabPanel>
            <TabPanel value={value} index={4}>
              Item Five
            </TabPanel>
            <TabPanel value={value} index={5}>
              Item Six
            </TabPanel>
          </Box>
        </div>
      </div>

      <section className="container mb-5 discover-div">
        <div>
          <h4 className="disco-h4">Also discover</h4>
        </div>
        <div className="row requ-div">
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="./hardwaresolution" className="icons-BC mb-4">
              <img className="icons-com" src={hardSolu} alt="" />
              <div className="icons-text">
                <h6 className="icons-h6">Hardware solution</h6>
                <p className="text-com-p">
                  HP, HPE, CISCO, JUNIPER, F5, FORTINET, SHOPHOS
                </p>
              </div>
            </a>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="./manangedServices" className="icons-BC">
              <img className="icons-com" src={manageSer} alt="" />
              <div className="icons-text">
                <h6 className="icons-h6">Manged Service</h6>
                <p className="text-com-p">
                  BreakFix, Monitoring, Help desk, Resource outsourcing
                </p>
              </div>
            </a>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="./securitySarvillance" className="icons-BC">
              <img className="icons-com" src={securityServillience} alt="" />
              <div className="icons-text">
                <h6 className="icons-h6">Security & Surveillance</h6>
                <p className="text-com-p">
                  HikVision, ZKTEco, Grrrett, Suprema, P A System
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>
      <section>
        <div className="data-inpu-text-div">
          <h3 className="data-inpu-text-h3">Request a Quote</h3>
          <p className="data-inpu-text-p">
            At nam minimum ponderum. Est audiam animal molestiae te. Ex duo
            eripuit mentitum. At nam minimum ponderum. Est audiam animal
            molestiae.
          </p>
        </div>
        <div>
          <img className="data-lower-back-img" src={dcLowerBg} alt="" />
        </div>
        <div className="hard-lower-part ">
          <div className="data-lower-full-input-div container">
            <div className="row g-2">
              <div className="col-md ">
                <div className="form-floating">
                  <input
                    type="name"
                    class="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Your Name</label>
                </div>
              </div>
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="email"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Email</label>
                </div>
              </div>
            </div>
            <div className="row g-2 mt-2">
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="number"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Contact No</label>
                </div>
              </div>
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingSelectGrid">Company</label>
                </div>
              </div>
            </div>
            <div className="row g-2 mt-2">
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingSelectGrid">What You Need ?</label>
                </div>
              </div>
              <div className="col-md">
                <div className="form-floating">
                  <input
                    type="email"
                    class="form-control"
                    id="floatingInputGrid"
                  />
                  <label for="floatingInputGrid">Reffrence Sources</label>
                </div>
              </div>
            </div>
            <div className="form-floating mt-3">
              <textarea
                className="form-control hard-texT-area"
                placeholder="Leave a comment here"
                id="floatingTextarea"
              ></textarea>
              <label for="floatingTextarea">Your Quarries</label>
            </div>
            <div>
              <button className="data-submit-button" type="submit">
                Submit Your Request
              </button>
            </div>
          </div>
        </div>
      </section>
      <section>
        <Footer />
      </section>
    </div>
  );
};

export default DataCenter;
